var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Youtube-White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.821,
    height: 22.54,
    viewBox: "0 0 31.821 22.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Youtube",
    d: "M15.911,22.54c-.083,0-8.3-.079-10.819-.323-.12-.023-.265-.04-.432-.06a4.676,4.676,0,0,1-3.077-1.31A7,7,0,0,1,.318,17.666,49.29,49.29,0,0,1,0,12.48V10.049A49.339,49.339,0,0,1,.318,4.862,7,7,0,0,1,1.582,1.681,4.37,4.37,0,0,1,4.569.346l.2-.021C9.173,0,15.837,0,15.9,0h.014c.067,0,6.73,0,11.133.325l.2.021a4.367,4.367,0,0,1,2.986,1.336A7.012,7.012,0,0,1,31.5,4.862a49.307,49.307,0,0,1,.318,5.187V12.48a49.323,49.323,0,0,1-.318,5.187,7.013,7.013,0,0,1-1.265,3.181,4.372,4.372,0,0,1-2.982,1.336l-.206.022C22.645,22.526,15.977,22.54,15.911,22.54ZM12.624,6.422v9l8.6-4.486Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.3adbeb1279094d7374096ed37a9a49f1.svg";
export { ForwardRef as ReactComponent };